import React from "react";
import PropTypes from "prop-types";
import { AlertCircle, CheckCircle2, Info, TriangleAlert } from "lucide-react";

const icons = { error: AlertCircle, info: Info, success: CheckCircle2, warning: TriangleAlert };

const Alert = ({ children, className = "", title, type = "info" }) => {
  const Icon = icons[type] || Info;
  return (
    <div className={["wsm-alert", `wsm-alert--${type}`, className].filter(Boolean).join(" ")} role={type === "error" ? "alert" : "status"}>
      <Icon aria-hidden="true" className="wsm-alert__icon" />
      <div className="wsm-alert__content">
        {title && <strong>{title}</strong>}
        <div className="wsm-alert__message">{children}</div>
      </div>
    </div>
  );
};

Alert.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.oneOf(["error", "info", "success", "warning"]),
};

export default Alert;
